<template>
  <div class="modal topup-modal">
    <div class="overlay" @click="$parent.closeTopUpModal"></div>
    <div class="wrapper">
      <div class="container">
        <img
          class="close"
          @click="$parent.closeTopUpModal"
          src="./../images/close.svg"
        />
        <div class="form-container">
          <ValidationObserver
            v-if="step === 1"
            slim
            v-slot="{ handleSubmit, valid, pristine }"
          >
            <form @submit.prevent="handleSubmit(passFirstStep)">
              <div class="form">
                <div class="title small">
                  {{ $t("Top up your balance") }}
                </div>
                <div class="method">
                  <div class="desc small desc-gray">
                    <b>{{ $t("Payment method") }}</b>
                  </div>
                  <div class="desc small">
                    <b>{{ $t("Credit card") }}</b>
                    <img src="../images/card.svg" alt="" />
                  </div>
                </div>
                <ValidationProvider
                  slim
                  rules="required|min_value:0.01"
                  name="Amount"
                  vid="amount"
                >
                  <label class="label">
                    <div class="desc desc-12">
                      <b>{{ $t("Enter amount (€)") }}:</b>
                    </div>
                    <div class="input-container">
                      <input
                        @input="allowOnlyNumbers"
                        required
                        name="amount"
                        v-model="amount"
                        type="text"
                        value="5"
                      />
                    </div>
                  </label>
                </ValidationProvider>
                <div class="button-list">
                  <div
                    @click="amount = 5"
                    :class="['button', { active: amount == 5 }]"
                  >
                    5 €
                  </div>
                  <div
                    @click="amount = 10"
                    :class="['button', { active: amount == 10 }]"
                  >
                    10 €
                  </div>
                  <div
                    @click="amount = 25"
                    :class="['button', { active: amount == 25 }]"
                  >
                    25 €
                  </div>
                  <div
                    @click="amount = 50"
                    :class="['button', { active: amount == 50 }]"
                  >
                    50 €
                  </div>
                  <div
                    @click="amount = 100"
                    :class="['button', { active: amount == 100 }]"
                  >
                    100 €
                  </div>
                </div>
              </div>
              <div class="amount-container">
                <div class="amount">
                  <div class="desc desc-12">{{ $t("You get") }}:</div>
                  <div class="desc small">
                    <b>{{ pointsAmount }}</b>
                    <img class="coin" src="../images/coin.svg" />
                  </div>
                </div>
                <button type="submit" class="button colored">
                  {{ $t("NEXT") }}
                </button>
              </div>
            </form>
          </ValidationObserver>
          <ValidationObserver
            v-else
            slim
            v-slot="{ handleSubmit, valid, pristine }"
          >
            <form class="step-2" @submit.prevent="handleSubmit(checkout)">
              <div class="form">
                <div class="title small">
                  {{ $t("Top up your balance") }}
                </div>
                <ValidationProvider
                  slim
                  rules="required"
                  name="Name"
                  vid="name"
                >
                  <label class="label">
                    <div class="desc desc-12">
                      <b>{{ $t("Name") }}:</b>
                    </div>
                    <input required name="name" v-model="name" type="text" />
                  </label>
                </ValidationProvider>
                <ValidationProvider
                  slim
                  rules="required"
                  name="Surname"
                  vid="surname"
                >
                  <label class="label">
                    <div class="desc desc-12">
                      <b>{{ $t("Surname") }}:</b>
                    </div>
                    <input
                      required
                      name="surname"
                      v-model="surname"
                      type="text"
                    />
                  </label>
                </ValidationProvider>
                <ValidationProvider
                  slim
                  rules="required|email"
                  name="Email"
                  vid="email"
                >
                  <label class="label">
                    <div class="desc desc-12">
                      <b>{{ $t("E-mail") }}:</b>
                    </div>
                    <input required name="email" v-model="email" type="email" />
                  </label>
                </ValidationProvider>
                <ValidationProvider
                  slim
                  rules="required"
                  name="Phone"
                  vid="phone"
                >
                  <label class="label">
                    <div class="desc desc-12">
                      <b>{{ $t("Phone") }}:</b>
                    </div>
                    <input required name="phone" v-model="phone" type="text" />
                  </label>
                </ValidationProvider>
                <ValidationProvider
                  slim
                  rules="required"
                  name="Country"
                  vid="country"
                >
                  <label class="label">
                    <div class="desc desc-12">
                      <b>{{ $t("Country") }}:</b>
                    </div>
                    <select required name="country" v-model="country">
                      <option disabled selected value="">
                        {{ $t("Country") }}
                      </option>
                      <option
                        v-for="(item, i) in countryOptions"
                        :value="item.id"
                        :key="i"
                      >
                        {{ item.title }}
                      </option>
                    </select>
                  </label>
                </ValidationProvider>
                <ValidationProvider
                  slim
                  rules="required"
                  name="City"
                  vid="city"
                >
                  <label class="label">
                    <div class="desc desc-12">
                      <b>{{ $t("City") }}:</b>
                    </div>
                    <input
                      required
                      type="text"
                      name="city"
                      :placeholder="$t('City')"
                      v-model="city"
                    />
                  </label>
                </ValidationProvider>

                <ValidationProvider
                  slim
                  rules="required"
                  name="Address"
                  vid="address"
                >
                  <label class="label">
                    <div class="desc desc-12">
                      <b>{{ $t("Address") }}:</b>
                    </div>
                    <input
                      required
                      type="text"
                      name="address"
                      :placeholder="$t('Address')"
                      v-model="address"
                    />
                  </label>
                </ValidationProvider>

                <ValidationProvider
                  slim
                  rules="required"
                  name="Post code"
                  vid="postCode"
                >
                  <label class="label">
                    <div class="desc desc-12">
                      <b>{{ $t("Zip") }}:</b>
                    </div>
                    <input
                      required
                      type="text"
                      name="postcode"
                      :placeholder="$t('Post Code')"
                      v-model="postCode"
                    />
                  </label>
                </ValidationProvider>
                <label class="label">
                  <ValidationProvider
                    mode="passive"
                    slim
                    :rules="{ required: { allowFalse: false } }"
                    vid="agree"
                    v-slot="{ errors }"
                  >
                    <div class="agree">
                      <checkbox class="desc small" v-model="agree">
                        <span>
                          {{ $t("I agree with") }}
                          <a class="link" @click="$parent.goToPage('privacy')">
                            <b>{{ $t("Privacy notice") }}</b>
                          </a>
                          {{ $t("and") }}
                          <a class="link" @click="$parent.goToPage('terms')">
                            <b>{{ $t("Terms and Conditions") }}</b>
                          </a>
                        </span>
                      </checkbox>
                      <div v-if="errors.length" class="error text-orange-red">
                        {{ $t("Please agree with rules") }}
                      </div>
                    </div>
                  </ValidationProvider>
                </label>
              </div>
              <transition name="slide">
                <div v-if="error" class="general-error">{{ error }}</div>
              </transition>
              <div class="amount-container">
                <div class="amount">
                  <div class="desc desc-12">{{ $t("You get") }}:</div>
                  <div class="desc small">
                    <b>{{ pointsAmount }}</b>
                    <img class="coin" src="../images/coin.svg" />
                  </div>
                </div>
                <button type="submit" class="button colored">
                  {{ $t("Pay") }}
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import axios from "@/axios";
import { mapGetters } from "vuex";
import Checkbox from "@/components/Checkbox.vue";

export default {
  name: "TopUpModal",
  props: [],
  components: {
    ValidationProvider,
    ValidationObserver,
    Checkbox,
  },
  created() {
    if (this.bundleId) {
      this.getCountries();
      this.bundle = this.bundles(this.bundleId);
      this.amount = this.bundle.price;
      this.step = 2;
    }
  },
  mounted() {
    this.email = this.profile.email;
    this.name = this.profile.name;
    this.surname = this.profile.surname;
    this.phone = this.profile.phone;
  },
  data: function () {
    return {
      amount: 5,
      email: "",
      name: "",
      surname: "",
      phone: "",
      country: "",
      countryId: "",
      city: "",
      address: "",
      postCode: "",
      step: 1,
      countryOptions: [],
      error: "",
      bundle: {},
      agree: false,
    };
  },
  methods: {
    allowOnlyNumbers() {
      this.amount = this.amount.replace(/[^0-9+.,]/g, "");
      const parts = this.amount.split(/[.,]/);
      const integerPart = parts[0];
      let decimalPart = parts[1];
      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }
      this.amount =
        decimalPart !== undefined
          ? `${integerPart}.${decimalPart}`
          : integerPart;
    },
    passFirstStep() {
      if (!this.countryOptions.length) {
        this.getCountries();
      }

      this.step = 2;
    },
    getCountries() {
      axios.get("countries").then((res) => {
        this.countryOptions = res.data.payload;
      });
    },
    checkout() {
      const data = {
        email: this.email,
        name: this.name,
        surname: this.surname,
        phone: this.phone,
        country: this.country,
        city: this.city,
        address: this.address,
        postCode: this.postCode,
      };

      if (this.bundleId) {
        data["bundle_id"] = this.bundleId;
      } else {
        data["amount"] = this.amount;
      }

      axios
        .post("deposit/checkout", data)
        .then((res) => {
          if (res.data.status == "OK") {
            window.location = res.data.redirect_url;
          } else {
            this.error = res.response.data.message;
          }
        });
      // .catch((res) => {
      //   this.error = res.response.data.message
      //   if (res.response.status === 401) {
      //     this.openSignInModal();
      //   }
      // })
    },
  },
  computed: {
    ...mapGetters("user", ["profile"]),
    ...mapGetters("app", ["bundleId", "bundles", "settings"]),
    pointsAmount() {
      return this.bundle.points
        ? this.bundle.points
        : this.amount * this.settings("points_convertion_rate");
    },
  },
};
</script>

<style lang="scss">
.modal .wrapper {
  overflow-y: hidden;

  .container {
    overflow-y: auto;
  }
}
</style>
